<template>
  <div class="search-wrapper">
    <div>
      <Row :gutter="32">
        <slot></slot>
      </Row>
    </div>
  </div>
</template>
<script>
import {Col} from 'iview'
  const Item = {
    name: 'SearchListItem',
    props: {
      label: {
        type: String,
        default: '',
        required: false,
      },
    },
    inject: {
      col: {
        type: Number,
      },
    },
    render() {
      return (
            <div>
                <Col class="item-box" {...{ props: responsive[this.col] }}>
                    <div class="y-search-item">
                        <div class={ this.$props.label ? "y-search-label" : "none"} title={this.$props.label}>{this.$props.label}</div>
                        <div class={ this.$props.label ? "y-search-content" : "y-search-content btn-box"}>{this.$slots.default}</div>
                    </div>
                </Col>
                
            </div>
            
        )
    },
  }
  const responsive = {
    1: { xs: 24, sm: 24, md: 24,  lg: 24, xl: 24 },
    2: { xs: 24, sm: 12 },
    3: { xs: 24, sm: 12, md: 8 },
    4: { md: 8, lg: 6, xl: 6 },
  }
  export default {
    name: 'SearchForm',
    Item: Item,
    props: {
      col: {
        type: Number,
        required: false,
        default: 3,
      },
    },
    provide() {
      return {
        col: this.col > 4 ? 4 : this.col,
      }
    },
    data() {
      return {
        advanced: false,
      }
    },
    methods: {
    },
  }
</script>
<style scoped lang="less">
  /deep/ .ivu-date-picker{
    width: 100%;
  }
  /deep/ .ivu-select {
    width: 100%;
  }
  .search-wrapper {
    padding-bottom: 8px;
    padding: 8px 16px;
  }
  /deep/ .item-box {
    margin-bottom: 16px;
  }
  /deep/ .y-search-item {
    display: flex;
    margin-right: 0;
  }
  /deep/ .y-search-content {
    flex: 1 1;
    display: inline-block;
    vertical-align: middle;
    height: 38px;
    line-height: 38px;
  }
  /deep/ .none {
      display: none;
  }
  /deep/ .btn-box{
      text-align: center;
  }
  
  /deep/ .y-search-label {
    min-width: 36px;
    line-height: 38px;
    padding-right: 8px;
    width: 90px;
    text-align: justify;
    text-align-last: justify;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
//   .table-page-searcy-submitButtons {
//     display: block;
//     white-space: nowrap;
//   }
</style>



// WEBPACK FOOTER //
// src/common/components/searchForm.vue